export type SchoolId = "nus" | "ntu" | "smu" | "jcu" | "curtin";
export type IntakeSchoolId = SchoolId | "other";
export type IdentityId = "solo" | "share" | "parent" | "switch" | "other";

export const SCHOOL_IDS: SchoolId[] = ["nus", "ntu", "smu", "jcu", "curtin"];
export const INTAKE_SCHOOL_IDS: IntakeSchoolId[] = [...SCHOOL_IDS, "other"];
export const IDENTITY_IDS: IdentityId[] = [
  "solo",
  "share",
  "parent",
  "switch",
  "other",
];

export function isSchoolId(v: string | null): v is SchoolId {
  return v !== null && SCHOOL_IDS.includes(v as SchoolId);
}

export function isIntakeSchoolOther(school: string): school is "other" {
  return school === "other";
}

export function isIdentityId(v: string | null): v is IdentityId {
  return v !== null && IDENTITY_IDS.includes(v as IdentityId);
}

export const SCHOOL_LABELS: Record<SchoolId, string> = {
  nus: "NUS",
  ntu: "NTU",
  smu: "SMU",
  jcu: "JCU",
  curtin: "科廷",
};

export const IDENTITY_LABELS: Record<IdentityId, string> = {
  solo: "独自来读书",
  share: "想找人合租",
  parent: "家长安排",
  switch: "在新加坡换房",
  other: "情况不太一样",
};
